import { render, staticRenderFns } from "./InputPhoneNumber.vue?vue&type=template&id=9f8e4e3e&scoped=true"
import script from "./InputPhoneNumber.vue?vue&type=script&lang=js"
export * from "./InputPhoneNumber.vue?vue&type=script&lang=js"
import style0 from "./InputPhoneNumber.vue?vue&type=style&index=0&id=9f8e4e3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8e4e3e",
  null
  
)

export default component.exports